import WishlistDetails from "../../components/WishlistDetails/WishlistDetails";

const WishlistPage =()=>{
    return(
        <>
        <WishlistDetails/>
        </>
    );
}

export default WishlistPage;